import { call, put, takeLatest } from 'redux-saga/effects';
import apiCall from '../../helpers/ApiCall';
import apiRoot from '../../consts/apiRoot';
import {
  SEND_CONVERSATION_MESSAGE,
  SEND_CONVERSATION_MESSAGE_SUCCESS,
  SEND_CONVERSATION_MESSAGE_FAIL,
  ADD_NEW_MESSAGE
} from '../../redux/Conversations';

function* sendConversationMessageFlow({ payload: { hashId, message, }, }) {
  try {
    const endpoint = `${apiRoot}/messages`;
    const params = {
      hash_id: hashId,
      message: {
        body: message,
      },
    };
    const data = yield call(apiCall, { method: 'POST', endpoint, params, });

    yield put(SEND_CONVERSATION_MESSAGE_SUCCESS());
    yield put(ADD_NEW_MESSAGE({ data, hashId, }));
  } catch (error) {
    yield put(SEND_CONVERSATION_MESSAGE_FAIL(error));
  }
}

export default function* SendConversationMessage() {
  yield takeLatest(SEND_CONVERSATION_MESSAGE, sendConversationMessageFlow);
}
